import React, { FC } from 'react';
import BackButton from '@components/common/backButton';
import { useOperatorPanelSettingsWrapperContext } from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsWrapper/hooks';
import { SimpleOnPress } from '@interfaces/base';

export interface BackButtonWrapperProps extends Partial<SimpleOnPress> {
  text?: string;
}

const BackButtonWrapper: FC<BackButtonWrapperProps> = ({ onPress, text }) => {
  const { scale, onDefaultClose } = useOperatorPanelSettingsWrapperContext();

  return <BackButton scale={scale} onPress={onPress ?? onDefaultClose} text={text} style={{ top: scale(7), left: scale(3) }} />;
};

export default BackButtonWrapper;
